import _regeneratorRuntime from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import { createSysTeam, deleteSysTeam as _deleteSysTeam, deleteSysTeamByIds, updateSysTeam, findSysTeam, getSysTeamList } from "@/api/team"; //  此处请自行替换地址
import { formatTimeToStr } from "@/utils/date";
import infoList from "@/mixins/infoList";
export default {
  name: "SysTeam",
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getSysTeamList,
      dialogFormVisible: false,
      dialogTitle: "",
      type: "",
      deleteVisible: false,
      multipleSelection: [],
      formData: {
        name: ""
      }
    };
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time != "") {
        var date = new Date(time * 1000);
        return formatTimeToStr(date, "yyyy-MM-dd hh:mm:ss");
      } else {
        return "";
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? "是" : "否";
      } else {
        return "";
      }
    }
  },
  methods: {
    //条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    deleteRow: function deleteRow(row) {
      var _this = this;
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.deleteSysTeam(row);
      });
    },
    onDelete: function onDelete() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var ids, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              ids = [];
              if (!(_this2.multipleSelection.length == 0)) {
                _context.next = 4;
                break;
              }
              _this2.$message({
                type: 'warning',
                message: '请选择要删除的数据'
              });
              return _context.abrupt("return");
            case 4:
              _this2.multipleSelection && _this2.multipleSelection.map(function (item) {
                ids.push(item.ID);
              });
              _context.next = 7;
              return deleteSysTeamByIds({
                ids: ids
              });
            case 7:
              res = _context.sent;
              if (res.code == 0) {
                _this2.$message({
                  type: 'success',
                  message: '删除成功'
                });
                if (_this2.tableData.length == ids.length) {
                  _this2.page--;
                }
                _this2.deleteVisible = false;
                _this2.getTableData();
              }
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    updateSysTeam: function updateSysTeam(row) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return findSysTeam({
                ID: row.ID
              });
            case 2:
              res = _context2.sent;
              _this3.type = "update";
              _this3.dialogTitle = '修改team';
              if (res.code == 0) {
                _this3.formData = res.data.resysTeam;
                _this3.dialogFormVisible = true;
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    closeDialog: function closeDialog() {
      this.dialogFormVisible = false;
      this.formData = {
        name: ""
      };
    },
    deleteSysTeam: function deleteSysTeam(row) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _deleteSysTeam({
                ID: row.ID
              });
            case 2:
              res = _context3.sent;
              if (res.code == 0) {
                _this4.$message({
                  type: "success",
                  message: "删除成功"
                });
                if (_this4.tableData.length == 1) {
                  _this4.page--;
                }
                _this4.getTableData();
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    enterDialog: function enterDialog() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.t0 = _this5.type;
              _context4.next = _context4.t0 === "create" ? 3 : _context4.t0 === "update" ? 7 : 11;
              break;
            case 3:
              _context4.next = 5;
              return createSysTeam(_this5.formData);
            case 5:
              res = _context4.sent;
              return _context4.abrupt("break", 15);
            case 7:
              _context4.next = 9;
              return updateSysTeam(_this5.formData);
            case 9:
              res = _context4.sent;
              return _context4.abrupt("break", 15);
            case 11:
              _context4.next = 13;
              return createSysTeam(_this5.formData);
            case 13:
              res = _context4.sent;
              return _context4.abrupt("break", 15);
            case 15:
              if (res.code == 0) {
                _this5.$message({
                  type: "success",
                  message: "创建/更改成功"
                });
                _this5.closeDialog();
                _this5.getTableData();
              }
            case 16:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    openDialog: function openDialog() {
      this.type = "create";
      this.dialogTitle = '新增team';
      this.dialogFormVisible = true;
    },
    openMemberPage: function openMemberPage(row) {
      this.$router.push({
        name: "teamMember",
        query: {
          teamId: row.ID,
          teamName: row.name,
          parent: true
        }
      });
    }
  },
  created: function created() {
    var _this6 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _this6.getTableData();
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  }
};